import { Play } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { ASSETS } from '@/assets';
import { PetPeek } from '@/components/PetPeek';

const STEP_MEDIA = [ASSETS.bottleHero, ASSETS.artMixSpray, null];

export const Steps = () => {
  const { t } = useLanguage();
  return (
    <section id="how-it-works" className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
      <PetPeek type="cat" className="top-16 right-2 hidden lg:block" />
      <div className="max-w-2xl space-y-3">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-orange">{t.steps.overline}</p>
        <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight text-brand-green">{t.steps.title}</h2>
        <p className="text-base md:text-lg font-medium text-brand-green/80">{t.steps.subtitle}</p>
      </div>

      <div className="mt-14 border-t-2 border-brand-green/15">
        {t.steps.items.map((step, i) => (
          <div key={step.title} className="grid grid-cols-12 gap-6 py-12 border-b-2 border-brand-green/15 items-center" data-testid={`step-${i + 1}`}>
            <span className="col-span-12 md:col-span-3 font-display text-7xl md:text-8xl leading-none text-brand-orange">
              0{i + 1}
            </span>
            <div className="col-span-12 md:col-span-5 space-y-3">
              <h3 className="font-display text-3xl md:text-4xl uppercase text-brand-green">{step.title}</h3>
              <p className="text-base md:text-lg font-medium leading-relaxed text-brand-green/80">{step.text}</p>
            </div>
            <div className="col-span-12 md:col-span-4">
              {STEP_MEDIA[i] ? (
                <div className="rounded-2xl overflow-hidden border-2 border-brand-green/10 shadow-md aspect-[4/3] bg-brand-bone">
                  <img src={STEP_MEDIA[i]} alt={step.title} className={`w-full h-full ${i === 0 ? 'object-contain p-4 mix-blend-multiply' : 'object-cover'}`} loading="lazy" />
                </div>
              ) : (
                <div>
                  <div className="rounded-2xl overflow-hidden border-2 border-brand-green/10 shadow-lg relative">
                    <video
                      data-testid="how-it-works-video"
                      className="w-full aspect-video object-cover"
                      controls
                      playsInline
                      preload="none"
                      poster={ASSETS.artGallon}
                    >
                      <source src={ASSETS.video} type="video/mp4" />
                    </video>
                    <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-brand-orange text-white text-[10px] font-black uppercase px-3 py-1 rounded-full shadow pointer-events-none">
                      <Play className="w-3 h-3" fill="currentColor" /> Angry Tangerine
                    </div>
                  </div>
                  <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.15em] text-brand-green/60">{t.steps.videoLabel}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
